// IMPORTANT: This is another very important call which is needed to prevent
// the browser from allowing users to navigate back when they have logged out.
// This is connected to the code for ht.checkValidSession
$(window).on('unload', function () {
  $.noop();
});
